import React, { useMemo } from 'react';
import { Table } from 'components/ui';
import { useListBugFeature } from 'query/admin';
import { BUG_FEATURE_STATUS } from 'components/blocks/BugFeatureReportForm/useBugFeatureForm';
import getBugFeatureListColumns from './getBugFeatureListColumns';

export default function InProgressBugFeatureList({ onSelect }) {
  const { data, isLoading } = useListBugFeature({
    status: BUG_FEATURE_STATUS.IN_PROGRESS,
  });
  const tableColumns = useMemo(() => {
    const columns = getBugFeatureListColumns({ onSelect });
    return [
      columns.type,
      columns.id,
      columns.summary,
      columns.reporter,
      columns.selectedBy,
      columns.dateSelected,
      columns.dateReported,
      columns.inProgressAction,
    ];
  }, [onSelect]);
  return (
    <Table
      columns={tableColumns}
      dataSource={data || []}
      loading={isLoading}
      rowKey="id"
    />
  );
}
